import {CommonModule} from '@angular/common'
import {NgModule} from '@angular/core'
import {FormsModule} from '@angular/forms'
import {RouterModule} from '@angular/router'
import {NbAuthModule} from '@nebular/auth'
import {AngularFontAwesomeModule} from 'angular-font-awesome'
import {
  NbAlertModule,
  NbButtonModule,
  NbCheckboxModule,
  NbInputModule,
  NbSelectModule,
  NbCardModule,
  NbLayoutModule
} from '@nebular/theme'
import {PaymentComponent} from './payment.component'
import {PaymentChargeComponent} from './payment-charge/payment-charge.component';
import {PaymentContainerComponent } from './payment-container/payment-container.component'

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    NbAlertModule,
    NbInputModule,
    NbButtonModule,
    NbCheckboxModule,
    NbAuthModule,
    NbSelectModule,
    NbCheckboxModule,
    AngularFontAwesomeModule,
    NbCardModule,
    NbLayoutModule
  ],
  declarations: [PaymentChargeComponent, PaymentComponent, PaymentContainerComponent]
})
export class PaymentModule {}
